import { LogEvent } from "../index";
import { deepFindLog, getClickPositionParams, isHtmlOrSvg } from "../utils/index";
const MESSAGE_EVENT_TYPE = "heatmap_inner_message";
const DEFAULT_CLICK_NAME = "search_heatmap_click";
const DEFAULT_ERROR_TYPE = "heatmap_inner_error";
const DEFAULT_ERROR_CLICK_TYPE = "heatmap_inner_click_error";
const DEFAULT_VERSION = "-1";
const DEFAULT_OPTIONS = {
  version: DEFAULT_VERSION,
  event: {
    click_name: DEFAULT_CLICK_NAME
  }
};

const catchSyncErrors = (fn, errType = DEFAULT_ERROR_TYPE) => {
  return (...args) => {
    try {
      return fn(...args);
    } catch (err) {
      const tags = {
        error_type: errType
      };
      console.error(err);

      try {
        if (window.Slardar) {
          window.Slardar("Sentry", Sentry => {
            Sentry.withScope(scope => {
              scope.setTags(tags);
              Sentry.captureException(err);
            });
          });
        }
      } catch (innerErr) {
        console.error("Sentry Error!");
      }
    }
  };
};

export class Heatmap {
  constructor(sendLog, options = DEFAULT_OPTIONS, wil) {
    this.cusEvent = document.createDocumentFragment();

    this.init = sendLog => {
      this.cusEvent.addEventListener(MESSAGE_EVENT_TYPE, catchSyncErrors(e => {
        const {
          detail
        } = e;
        this.onMessage(detail, sendLog, this.options);
      }));
      this.onClick();
    };

    this.onClick = () => {
      const {
        event
      } = this.options;
      const eventName = event && event.click_name || DEFAULT_CLICK_NAME;
      window.document.addEventListener("click", catchSyncErrors(e => {
        const tgt = e.target;

        if (!isHtmlOrSvg(tgt)) {
          return;
        }

        const params = getClickPositionParams(e);

        if (params) {
          const area = this.findShowArea(tgt);
          this.cusEvent.dispatchEvent(new CustomEvent(MESSAGE_EVENT_TYPE, {
            detail: {
              tgt,
              logPath: [Object.assign(Object.assign({
                event: eventName
              }, params), area && {
                module_name: area
              })],
              info: {
                type: "heatmap_click"
              }
            }
          }));
        }
      }, DEFAULT_ERROR_CLICK_TYPE), true);
    };

    this.findShowArea = target => {
      if (!this.wil) {
        return undefined;
      }

      const attributeName = this.wil.config["data-log-view"];
      const attributeExtraName = this.wil.config["data-log-extra"];
      const log = deepFindLog(target, attributeName, attributeExtraName);

      if (log && log.length > 0) {
        let l = log.length;

        for (let i = 0; i < l; i++) {
          const {
            module_name
          } = log[i] || {};

          if (module_name) {
            return module_name;
          }
        }
      }

      return undefined;
    };

    this.onMessage = (data, sendLog, options) => {
      const {
        origin,
        pathname,
        search
      } = window.location;
      const {
        version = DEFAULT_VERSION
      } = options;
      const {
        tgt,
        logPath,
        info
      } = data;
      const log = {
        page_origin: origin,
        page_version: version,
        page_pathname: pathname,
        page_search: search
      };
      logPath.push(log);
      sendLog(new LogEvent(tgt, logPath, info));
    };

    this.adaptConfig = options => {
      return Object.assign(Object.assign(Object.assign({}, DEFAULT_OPTIONS), options), {
        event: Object.assign(Object.assign({}, DEFAULT_OPTIONS.event), options.event)
      });
    };

    this.options = this.adaptConfig(options);
    this.init(sendLog);
    this.wil = wil;
  }

}